export default "__VITE_ASSET__DfH2g7yU__"